// extracted by mini-css-extract-plugin
export var actions = "articleVoteForm-module--actions--c72b8";
export var articleVoteForm = "articleVoteForm-module--articleVoteForm--0c799";
export var button = "articleVoteForm-module--button--c5e8b";
export var checkboxContainer = "articleVoteForm-module--checkboxContainer--cbfa0";
export var dark = "articleVoteForm-module--dark--fd641";
export var feedbackThanks = "articleVoteForm-module--feedbackThanks--4182c";
export var hasFeedback = "articleVoteForm-module--hasFeedback--7c08c";
export var headline = "articleVoteForm-module--headline--59081";
export var light = "articleVoteForm-module--light--86902";
export var subhead = "articleVoteForm-module--subhead--654b4";